import { DISPUTES_STATUSES } from './disputes';
import { FEE_STATUSES } from './fees';
import { KYC_STATUSES } from './kyc';
import { PAYOUT_STATUSES } from './payout';
import { SETTLEMENT_STATUSES } from './settlements';
import { TRANSACTION_STATUSES } from './transactions';
import { WALLET_CONVERSIONS_STATUSES } from './wallet-conversions';

const STATUSES = {
  disputes: DISPUTES_STATUSES,
  settlements: SETTLEMENT_STATUSES,
  transactions: TRANSACTION_STATUSES,
  payout: PAYOUT_STATUSES,
  fees: FEE_STATUSES,
  kyc: KYC_STATUSES,
  conversion: WALLET_CONVERSIONS_STATUSES
};

export { STATUSES };
